<script setup>
import * as iotapi from "../iotapi.js";
import { ref, onMounted, computed } from "vue";
import * as L from "leaflet";
import "leaflet/dist/leaflet.css";
import "leaflet-defaulticon-compatibility/dist/leaflet-defaulticon-compatibility.webpack.css";
import "leaflet-defaulticon-compatibility";

const htmlMap = ref(null);

const props = defineProps({
  sensor: Object,
  mantenimiento: {
    type: Array,
    default: () => [],
  },
});

const actualizado = computed(() => {
  return iotapi.parseDateApi(props.sensor.timeinstant).toLocaleString();
});

const t = (key) => {
  return iotapi.i18next.t(key);
};

const calidadImg = (valor) => {
  let alt = "";
  let src = "../img/iconos/no-img.png";
  const calidad = props.sensor[valor + "-index"];
  if (calidad) {
    alt = iotapi.i18next.t("smart.tiemporeal.calidad3_" + calidad);
    src = "../img/iconos/calidad3-" + calidad + ".png";
  }
  return { alt, src };
};

const redondea = (valor, minimumFractionDigits, maximumFractionDigits) => {
  return Number.parseFloat(valor).toLocaleString(undefined, { minimumFractionDigits, maximumFractionDigits });
};

onMounted(() => {
  const map = L.map(htmlMap.value, { zoom: 16, scrollWheelZoom: false, dragging: false });
  map.attributionControl.setPrefix(
    '<a href="https://leafletjs.com" title="A JavaScript library for interactive maps">Leaflet</a>',
  );
  L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
    attribution:
      '&copy; <a title="OpenStreetMap" href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
  }).addTo(map);
  L.geoJSON(JSON.parse(props.sensor.location), {
    pointToLayer: function (geoJsonPoint, latlng) {
      map.panTo(latlng);
      return L.marker(latlng);
    },
  }).addTo(map);
});
</script>

<template>
  <li class="col-xl-4 col-md-6 col-sm-12 my-3">
    <div class="h-100 d-flex flex-column sensor rounded bg-contrast shadow-lg">
      <p class="text-center sim_h5">{{ sensor.name }}</p>
      <dl class="row">
        <dt class="col-6">{{ t("smart.tiemporeal.particulas") }} &#60; 10 µm:</dt>
        <dd class="col-6 text-danger" v-if="mantenimiento.includes('pm10')">{{ t("smart.mantenimiento") }}</dd>
        <dd class="col-6" v-else><img v-bind="calidadImg('pm10')" />{{ redondea(sensor.pm10, 1, 1) }} µg/m3</dd>
        <dt class="col-6">{{ t("smart.tiemporeal.particulas") }} &#60; 2,5 µm:</dt>
        <dd class="col-6 text-danger" v-if="mantenimiento.includes('pm25')">{{ t("smart.mantenimiento") }}</dd>
        <dd class="col-6" v-else><img v-bind="calidadImg('pm25')" />{{ redondea(sensor.pm25, 1, 1) }} µg/m3</dd>
        <dt class="col-6">{{ t("smart.tiemporeal.particulas") }} &#60; 1 µm:</dt>
        <dd class="col-6 text-danger" v-if="mantenimiento.includes('pm1')">{{ t("smart.mantenimiento") }}</dd>
        <dd class="col-6" v-else><img v-bind="calidadImg('pm1')" />{{ redondea(sensor.pm1, 1, 1) }} µg/m3</dd>
      </dl>
      <div class="d-none d-md-block mt-auto"></div>
      <div ref="htmlMap" class="sensor-map"></div>
      <p class="text-center small">{{ t("smart.tiemporeal.actualizado") }} {{ actualizado }}</p>
    </div>
  </li>
</template>
